
import React, { useEffect, useState } from 'react';
import { Dropdown as _Dropdown, DropdownToggle, DropdownItem } from '@patternfly/react-core';
import CaretDownIcon from '@patternfly/react-icons/dist/js/icons/caret-down-icon';

import './dropdown.scss';
import useTranslateText from '../use_translate_text';

const Dropdown = (props) => {
  const defaultState = {
          dropdownItems: [],
          isOpen: false,
          selectedItem: { label: '', key: '' },
        },
        { translateText } = useTranslateText(),
        [state, setState] = useState(defaultState),
        setStateData = (stateName, Fields) => {
          setState(prevState => ({
            ...prevState,
            [stateName]: Fields,
          }));
        };

  useEffect(() => {
    const { data, selectedItem: value } = props,
          dropdownItems = [];
    let newSelectedItem = '',
        selectedValue = value;

    data.map(item => {
      const { value, label } = item,
            isSelectedItem = value === selectedValue,
            itemProps = {
              ...item,
              className: isSelectedItem && 'active',
            },
            dropdownItem = <DropdownItem {...itemProps}>
              {translateText(label)}
            </DropdownItem>;

      if (isSelectedItem) newSelectedItem = { ...item };

      dropdownItems.push(dropdownItem);
    });
    setStateData('dropdownItems', dropdownItems);
    setStateData('selectedItem', newSelectedItem);
  }, [props]);

  const onToggle = () => {
          const { isOpen } = state;
          setStateData('isOpen', !isOpen);
        },
        onSelect = (e) => {
          const { isOpen } = state,
                { onSelect } = props,
                value = e.target.getAttribute('value'),
                label = e.target.getAttribute('label'),
                selectedItem = { value, label };

          setStateData('isOpen', !isOpen);
          setStateData('selectedItem', selectedItem);

          onSelect(value);
        };

  const { dropdownItems, isOpen, selectedItem } = state,
        { disabled, error, errorMessage } = props;

  return (
    <>
      <_Dropdown
        className={`dropdown ${error ? 'error' : ''}`}
        onSelect={e => onSelect(e)}
        toggle={
          <DropdownToggle
            id="toggle-id"
            onToggle={onToggle}
            toggleIndicator={CaretDownIcon}
            isDisabled={disabled}
          >
            { translateText(selectedItem.label) || translateText('*no value') }
          </DropdownToggle>
        }
        isOpen={isOpen}
        dropdownItems={dropdownItems}
      />
      {error ?
        <p style={{ color: '#f44336', marginLeft: 0, marginRight: 0, margin: 0,
          fontSize: '0.75rem',
          marginTop: 3,
          textAlign: 'left', fontWeight: 400,
          lineHeight: 1.66,
          letterSpacing: '0.03333em' }}><span>{translateText(errorMessage)}</span></p> : null}
    </>
  );
};

export default Dropdown;